export default __webpack_public_path__ + "static/media/pile 2 1.ab0c50d7.png";